// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdowns-containers-navbar {
  margin-top: 20px !important;
  width: 98% !important;
  display: flex;
  padding: 0 !important;
  flex-direction: row;
  align-self: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1607843137);
}
.dropdowns-containers-navbar .btn-primary {
  background: #ffffff 0% 0% no-repeat !important;
  color: #000000 !important;
  font-family: "Lato", sans-serif !important;
  opacity: 1;
  border-radius: 0px !important;
  padding: 15px 10px 15px 10px;
  min-width: 120px;
  border: 0px solid rgba(0, 0, 0, 0) !important;
  font-size: 13px;
}

.dropdown {
  padding: 0 !important;
}

.navbar-profile-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.dropdown > .dropdown-toggle:active {
  pointer-events: none;
}

.dropdownRole {
  text-overflow: initial;
  overflow: visible !important;
}

.list-unstyled a {
  color: #000000;
  font-family: "Lato", sans-serif !important;
  font-size: 14px;
  padding: 10px 20px !important;
}

.search-input-role {
  width: 93% !important;
}

#dropdown-custom-components {
  text-overflow: ellipsis;
  overflow: hidden;
}

.dropdown {
  width: max-content !important;
  position: relative;
  left: -2rem;
  text-overflow: ellipsis;
  overflow: hidden;
}

.dropdown-item {
  color: #bc0000;
  font-family: "Lato", sans-serif !important;
  font-size: 14px;
}

.container-dropdown-collapse {
  position: absolute;
  z-index: 1;
  right: 0;
  background-color: rgb(255, 255, 255);
  width: 350px !important;
  max-height: 350px;
  overflow-y: scroll;
}

.priority-nav {
  justify-content: center !important;
  align-items: center !important;
  align-content: center !important;
}

.contaner-popover {
  width: 50px !important;
}

.button-more-menu {
  font-size: 14px;
  font-family: "Lato", sans-serif !important;
  color: #000000;
  align-self: flex-end !important;
  text-align: center;
  padding: 0px !important;
  margin: 0px !important;
}

.title-menu-collapse {
  font-family: "Lato", sans-serif !important;
  font-size: 14px;
  padding: 10px 0px !important;
  margin: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/navbarProfile/navbarProfile.scss","webpack://./src/sass/layout/navbarProfile/navbarProfile.css","webpack://./src/sass/utilities/_variables.scss","webpack://./src/sass/utilities/_mixins.scss"],"names":[],"mappings":"AAGA;EAcE,2BAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+CAAA;EACA,oDAAA;ACfF;ADLE;EACE,8CAAA;EACA,yBAAA;EACA,0CELG;EFMH,UAAA;EACA,6BAAA;EACA,4BAAA;EACA,gBAAA;EACA,6CAAA;EACA,eAAA;ACOJ;;ADMA;EACE,qBAAA;ACHF;;ADKA;EG1BE,aAAA;EACA,uBH0BoB;EGzBpB,mBHyB4B;EAC5B,mBAAA;ACAF;;ADGA;EACE,oBAAA;ACAF;;ADEA;EACE,sBAAA;EACA,4BAAA;ACCF;;ADGE;EACE,cAAA;EACA,0CE3CG;EF4CH,eAAA;EACA,6BAAA;ACAJ;;ADGA;EACE,qBAAA;ACAF;;ADEA;EACE,uBAAA;EACA,gBAAA;ACCF;;ADCA;EACE,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;ACEF;;ADAA;EACE,cAAA;EACA,0CEhEK;EFiEL,eAAA;ACGF;;ADAA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,oCEjEM;EFkEN,uBAAA;EACA,iBAAA;EACA,kBAAA;ACGF;;ADAA;EACE,kCAAA;EACA,8BAAA;EACA,gCAAA;ACGF;;ADAA;EACE,sBAAA;ACGF;;ADAA;EACE,eAAA;EACA,0CE1FK;EF2FL,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;ACGF;;ADAA;EACE,0CEnGK;EFoGL,eAAA;EACA,4BAAA;EACA,sBAAA;ACGF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.dropdowns-containers-navbar {\n  .btn-primary {\n    background: #ffffff 0% 0% no-repeat !important;\n    color: #000000 !important;\n    font-family: $Font;\n    opacity: 1;\n    border-radius: 0px !important;\n    padding: 15px 10px 15px 10px;\n    min-width: 120px;\n    border: 0px solid $Transparent !important;\n    font-size: 13px;\n  }\n  // @include flexCenter(center, center);\n  // justify-content: space-around !important;\n  margin-top: 20px !important;\n  width: 98% !important;\n  display: flex;\n  padding: 0 !important;\n  flex-direction: row;\n  align-self: center;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 0px 15px #00000029;\n}\n.dropdown {\n  padding: 0 !important;\n}\n.navbar-profile-container {\n  @include flexCenter(center, center);\n  flex-direction: row;\n}\n\n.dropdown > .dropdown-toggle:active {\n  pointer-events: none;\n}\n.dropdownRole {\n  text-overflow: initial;\n  overflow: visible !important;\n}\n\n.list-unstyled {\n  a {\n    color: #000000;\n    font-family: $Font;\n    font-size: 14px;\n    padding: 10px 20px !important;\n  }\n}\n.search-input-role {\n  width: 93% !important;\n}\n#dropdown-custom-components {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.dropdown {\n  width: max-content !important;\n  position: relative;\n  left: -2rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.dropdown-item {\n  color: #bc0000;\n  font-family: $Font;\n  font-size: 14px;\n}\n\n.container-dropdown-collapse {\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  background-color: $White;\n  width: 350px !important;\n  max-height: 350px;\n  overflow-y: scroll;\n}\n\n.priority-nav {\n  justify-content: center !important;\n  align-items: center !important;\n  align-content: center !important;\n}\n\n.contaner-popover {\n  width: 50px !important;\n}\n\n.button-more-menu {\n  font-size: 14px;\n  font-family: $Font;\n  color: #000000;\n  align-self: flex-end !important;\n  text-align: center;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.title-menu-collapse {\n  font-family: $Font;\n  font-size: 14px;\n  padding: 10px 0px !important;\n  margin: 0px !important;\n}\n",".dropdowns-containers-navbar {\n  margin-top: 20px !important;\n  width: 98% !important;\n  display: flex;\n  padding: 0 !important;\n  flex-direction: row;\n  align-self: center;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1607843137);\n}\n.dropdowns-containers-navbar .btn-primary {\n  background: #ffffff 0% 0% no-repeat !important;\n  color: #000000 !important;\n  font-family: \"Lato\", sans-serif !important;\n  opacity: 1;\n  border-radius: 0px !important;\n  padding: 15px 10px 15px 10px;\n  min-width: 120px;\n  border: 0px solid rgba(0, 0, 0, 0) !important;\n  font-size: 13px;\n}\n\n.dropdown {\n  padding: 0 !important;\n}\n\n.navbar-profile-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n}\n\n.dropdown > .dropdown-toggle:active {\n  pointer-events: none;\n}\n\n.dropdownRole {\n  text-overflow: initial;\n  overflow: visible !important;\n}\n\n.list-unstyled a {\n  color: #000000;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px;\n  padding: 10px 20px !important;\n}\n\n.search-input-role {\n  width: 93% !important;\n}\n\n#dropdown-custom-components {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.dropdown {\n  width: -moz-max-content !important;\n  width: max-content !important;\n  position: relative;\n  left: -2rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.dropdown-item {\n  color: #bc0000;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px;\n}\n\n.container-dropdown-collapse {\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  background-color: rgb(255, 255, 255);\n  width: 350px !important;\n  max-height: 350px;\n  overflow-y: scroll;\n}\n\n.priority-nav {\n  justify-content: center !important;\n  align-items: center !important;\n  align-content: center !important;\n}\n\n.contaner-popover {\n  width: 50px !important;\n}\n\n.button-more-menu {\n  font-size: 14px;\n  font-family: \"Lato\", sans-serif !important;\n  color: #000000;\n  align-self: flex-end !important;\n  text-align: center;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.title-menu-collapse {\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px;\n  padding: 10px 0px !important;\n  margin: 0px !important;\n}/*# sourceMappingURL=navbarProfile.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n","@import \"./variables\";\n\n@mixin flexCenter($justify-content, $align-items) {\n  display: flex;\n  justify-content: $justify-content;\n  align-items: $align-items;\n}\n\n@mixin settingsPage() {\n  background-color: $MainBackgroundColor !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
